import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import App from './App.tsx'
import { logger } from './services/logger'
import { ENV } from './shared/config/env'
import { probePrimaryHost } from './shared/api/probePrimaryHost'
import { installAnalyticsFlush } from './entities/analytics'
import { PlatformProvider } from './app/providers/PlatformProvider'
import './index.css'

// В Telegram запрещаем масштабирование: WebView зумит страницу на фокусе поля,
// и экран остаётся увеличенным после закрытия клавиатуры. 16px у полей это
// предотвращает, но метатег закрывает и случаи, где размер задан не нами.
// В вебе не трогаем: там пинч-зум нужен для доступности.
if (ENV.IS_TG) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
    )
}

// Если в прошлый раз пришлось уйти на запасной бэкенд — фоном проверяем,
// не ожил ли основной. Ничего не блокирует: до ответа приложение работает
// на запомненном хосте.
probePrimaryHost()

// Накопленные события аналитики отправляем, когда приложение уходит в фон
// или закрывается: иначе хвост сессии теряется целиком.
installAnalyticsFlush()

// Глобальный перехват ошибок фронта — до монтирования React
window.addEventListener('error', (event) => {
  logger.logError(event.error || event.message, {
    errorType: 'unhandled_error',
    additionalData: {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
  })
})

window.addEventListener('unhandledrejection', (event) => {
  logger.logError(event.reason, {
    errorType: 'unhandled_promise_rejection',
  })
})

// Настройка React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 минут
    },
    mutations: {
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PlatformProvider>
        <BrowserRouter>
          <App />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </BrowserRouter>
      </PlatformProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
